import React from "react";
import { cva } from "class-variance-authority";
import { cn } from "@components/lib/utils";
import { Badge } from "@components/Badge/Badge";

const chipVariants = cva("", {
  variants: {
    variant: {
      default: "bg-[var(--border-grey)] rounded-full",
      error: "bg-[var(--light-red)] text-[var(--dark-red)] rounded-full",
      active: "bg-[var(--mint-green-light)] text-[var(--forest-green-dark)] rounded-full",
      inProgress: "bg-[var(--light-yellow)] text-[var(--dark-yellow)] rounded-full",
    },
  },
  defaultVariants: {
    variant: "default",
  },
});

export function Chip({ className, variant = "default", children }) {
  return (
    <Badge
      className={cn(chipVariants({ variant }), className)}
      variant="default" // ✅ use this to apply real badge styles
    >
      {children}
    </Badge>
  );
}
